import { createReducer, on } from '@ngrx/store';
import {
  ORDER_TYPE_FIND_SUCCESS,
  ORDER_TYPE_FAILED,
  ORDER_TYPE_UPDATE_LOADING,
  ORDER_TYPE_UPDATE
 } from '../actions'
import { OrderTypeEnum } from '@core/enums';
import { OrderType } from '@core/models';


export interface OrderTypeState {
  loading: boolean;
  orderTypeList: OrderType[] | null;
  orderType: OrderTypeEnum;
  error: string | null;
}

const initialState: OrderTypeState = {
  loading: false,
  orderTypeList: null,
  error: null,
  orderType: OrderTypeEnum.Pickup,
}

export const orderTypeReducer = createReducer(
  initialState,
  on(ORDER_TYPE_FIND_SUCCESS, (state, { orderTypeList }) => ({ ...state, orderTypeList })),
  on(ORDER_TYPE_FAILED, (state, { error }) => ({ ...state, error })),
  on(ORDER_TYPE_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(ORDER_TYPE_UPDATE, (state, { orderType }) => ({ ...state, orderType })),
);
